import { validateMessages } from '../../helper/common'
import cn from 'classnames'
import { CustomForm } from 'components/Forms/CustomForm'
import { initialStateForFees } from '../../features/Financials/SplitFees/CommunityProcessing/EditModal/constants'
import { TEditFeesForm, TEditFeesFormErrorType } from './forms.editFees.d'
import { FieldWithLabel } from '../FieldWithLabel/FieldWithLabel'
import { LABELS, TypeError } from '../../constants'
import { Input } from '../Input'
import { twoDecimalParser } from '../../features/ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { ReactComponent as ChevronDown16 } from 'assets/svg/ChevronDown16.svg'
import { ReactComponent as ChevronUp16 } from 'assets/svg/ChevronUp16.svg'
import { Typography } from '../Typography'
import './forms.editFees.scss'
import { useDispatch } from 'react-redux'
import { setLoading } from '../../redux/store/common/slice'
import { editFeesHSOption } from '../../features/Financials/api'
import { notification } from '../Notification'
import { useState } from 'react'

export const EditFeesForm = ({
  form,
  setIsActive,
  data,
  community,
  callback
}) => {
  const dispatch = useDispatch()
  const [errors, setErrors] = useState<TEditFeesFormErrorType | TypeError>({})
  const handleFinish = (formData: TEditFeesForm) => {
    setIsActive(false)
    dispatch(setLoading(true))
    editFeesHSOption(community, data.uuid, formData)
      .then(() => {
        notification.success({
          message: `OM processing fees for ${data.name} have been successfully saved. `
        })
        callback()
      })
      .catch((e) => {
        setIsActive(true)
        if (e.data.details) {
          notification.error({ message: e?.data.details })
        }
        setErrors(e.data)
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  return (
    <CustomForm<TEditFeesForm>
      form={form}
      onFinish={handleFinish}
      initialValues={initialStateForFees}
      validateMessages={validateMessages}
      onValuesChange={() => {
        setIsActive(true)
      }}
      id="edit-fees-form"
      className={cn('edit-fees-form')}
    >
      <FieldWithLabel
        title={LABELS.HEALTH_SYSTEM}
        className="prs-details-general__left__contract-category"
      >
        {data.name}
      </FieldWithLabel>
      <div className="row space-between two-in-row mb-16">
        <Input.Number
          className="spinner-input-number"
          propsItem={{
            name: 'rebate_fee',
            label: LABELS.REBATE_FEE,
            rules: [
              {
                required: true
              }
            ],
            help: errors.rebate_fee && errors.rebate_fee[0],
            validateStatus: errors.rebate_fee && 'error'
          }}
          propsInputNumber={{
            controls: { downIcon: <ChevronDown16 />, upIcon: <ChevronUp16 /> },
            min: '0',
            max: '100',
            parser: twoDecimalParser,
            placeholder: '0'
          }}
        />
        <Input.Number
          className="spinner-input-number"
          propsItem={{
            name: 'admin_fee',
            label: LABELS.ADMIN_FEE,
            rules: [
              {
                required: true
              }
            ],
            help: errors.admin_fee && errors.admin_fee[0],
            validateStatus: errors.admin_fee && 'error'
          }}
          propsInputNumber={{
            controls: { downIcon: <ChevronDown16 />, upIcon: <ChevronUp16 /> },
            min: '0',
            max: '100',
            parser: twoDecimalParser,
            placeholder: '0'
          }}
        />
      </div>
      <Input.Number
        className="spinner-input-number"
        propsItem={{
          name: 'contracting_labor',
          label: LABELS.CONTRACTING_LABOR,
          help: errors.contracting_labor && errors.contracting_labor[0],
          validateStatus: errors.contracting_labor && 'error',
          rules: [
            {
              required: true
            }
          ]
        }}
        propsInputNumber={{
          controls: { downIcon: <ChevronDown16 />, upIcon: <ChevronUp16 /> },
          min: '0',
          max: '100',
          parser: twoDecimalParser,
          placeholder: '0'
        }}
      />
      <Typography.Headline6 className="mt-24">
        Marketplace AR
      </Typography.Headline6>
      <div className="row space-between  two-in-row">
        <Input.Number
          className="spinner-input-number"
          propsItem={{
            name: 'marketplace_ar_vendor',
            label: 'Vendor, %',
            help:
              errors.marketplace_ar_vendor && errors.marketplace_ar_vendor[0],
            validateStatus: errors.marketplace_ar_vendor && 'error',
            rules: [
              {
                required: true
              }
            ]
          }}
          propsInputNumber={{
            controls: { downIcon: <ChevronDown16 />, upIcon: <ChevronUp16 /> },
            min: '0',
            max: '100',
            parser: twoDecimalParser,
            placeholder: '0'
          }}
        />
        <Input.Number
          className="spinner-input-number"
          propsItem={{
            name: 'marketplace_ar_health_system_split',
            label: LABELS.HS_SPLIT,
            help:
              errors.marketplace_ar_health_system_split &&
              errors.marketplace_ar_health_system_split[0],
            validateStatus:
              errors.marketplace_ar_health_system_split && 'error',
            rules: [
              {
                required: true
              }
            ]
          }}
          propsInputNumber={{
            controls: { downIcon: <ChevronDown16 />, upIcon: <ChevronUp16 /> },
            min: '0',
            max: '100',
            parser: twoDecimalParser,
            placeholder: '0'
          }}
        />
      </div>
    </CustomForm>
  )
}
